module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number) ? _c('div', [_c('div', {
    staticClass: "addon-booking-header brand--bg--dark"
  }, [(_vm.canRemoveConnection) ? _c('a', {
    staticClass: "transparent",
    attrs: {
      "href": "#/varukorg"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeConnection()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times-white",
      "scale": 2
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/varukorg"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeConnection()
      }
    }
  }, [(_vm.canRemoveConnection) ? _c('span', [_vm._v("Avsluta tilläggsbokning")]) : _vm._e(), _vm._v(" "), (!_vm.canRemoveConnection) ? _c('span', [_vm._v("Tilläggsbokning")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "white number",
    attrs: {
      "href": "#/mina-sidor"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBooking()
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$store.state.cart.addToOrder.number))])])]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addon-booking-header addon-booking-header--right brand--bg--dark"
  }, [_c('a', {
    staticClass: "white",
    attrs: {
      "href": "#/mina-sidor"
    }
  }, [_c('i', {
    staticClass: "fal fa-lock-alt"
  }), _vm._v("\n      Mina sidor\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "white",
    attrs: {
      "href": "#/varukorg"
    }
  }, [_c('i', {
    staticClass: "fal fa-shopping-cart"
  }), _vm._v("\n      Varukorg\n    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#modal_live-booking",
      "rel": "modal:open"
    }
  }, [_c('span', [_vm._v("Boka online")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360db154"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/AddonBookingHeader.vue
// module id = 926
// module chunks = 0